/* K-Beauty Real Gems — fit the brand statement to one line (desktop only). */
(function () {
  'use strict';
  function fit() {
    var p = document.querySelector('[data-krg-statement]');
    if (!p) return;
    if (window.innerWidth <= 820) { p.style.fontSize = ''; return; }
    p.style.fontSize = '100px';
    var ratio = p.clientWidth / p.scrollWidth;
    p.style.fontSize = Math.min(100 * ratio * 0.99, 120) + 'px';
  }
  window.addEventListener('load', fit);
  window.addEventListener('resize', fit);
  document.addEventListener('DOMContentLoaded', fit);
})();
